// JavaScript files are compiled and minified
// during the build process to the assets/built 
// folder. See available scripts in the package.json file.

// Import components
import setupGalleries from './galleries'
import setupSnippets from './snippets'

// Import JS
import menuOpen from './menuOpen'
import infiniteScroll from './infiniteScroll'

// Import all CSS
import '../css/index.css'

// Call the menu and infinite scroll functions
menuOpen()
infiniteScroll()

// Load all js when dom loaded
document.addEventListener('DOMContentLoaded', () => {
    setupGalleries()
    setupSnippets()
    console.log('theme plugins loaded')
})
